<script lang="ts">
  import { simpleUID } from "../support/uuid";

  export let src: string | null = null;

  export let icon = { src: src };
  export let size = 24;
  export let width = size;
  export let height = size;
  export let fill = "black";
  export let offsetX = 0;
  export let offsetY = 0;

  let id = `icon-${simpleUID()}`;
</script>

<svg {width} {height} aria-hidden="true" style="--offset-x: {offsetX}px; --offset-y: {offsetY}px;">
  {#if fill}
    <mask {id}>
      <image href={icon.src} {width} {height} />
    </mask>
    <slot />
    <rect {fill} {width} {height} mask="url(#{id})" />
  {:else}
    <slot />
    <image href={icon.src} {width} {height} />
  {/if}
</svg>

<style>
  svg {
    display: block;
    position: relative;
    left: var(--offset-x, 0);
    top: var(--offset-y, 0);
    overflow: visible;
  }

  mask {
    mask-type: alpha;
  }
</style>
